import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { notifications } from '@mantine/notifications';

type ActivateUserDTO = {
    user_uuid: string;
    token: string;
}

export const activateUser = ({ user_uuid, token }: ActivateUserDTO): Promise<ActivateUserResponse> => {
        return axios.get(`/users/activate/${user_uuid}/${token}`);
}

type UseActivateUserOptions = {
    config?: MutationConfig<typeof activateUser>;
}

export const useActivateUser = ({ config }: UseActivateUserOptions = {}) => {
    return useMutation({
        onMutate: async (activatingUser: any) => {
            await queryClient.cancelQueries(['activateUser']);

            const previousUser = queryClient.getQueryData<Event>([
                'activateUser',
                activatingUser?.user_uuid,
            ]);

            queryClient.setQueryData(['activateUser', activatingUser.user_uuid], {
                ...previousUser,
                ...activatingUser.data,
                uuid: activatingUser.user_uuid,
            });

            return { previousUser };
        },
        onError: (_,__, context: any) => {
            if (context?.previousUser) {
                queryClient.setQueryData(
                    ['activateUser'],
                    context.previousUser
                );
            }
            notifications.show({
                title: 'Error',
                message: 'An error occurred while activating the user ❌',
                color: 'red'
            });
        },
        onSuccess: () => {
            notifications.show({
                title: 'Success!',
                message: 'User activated ✅',
                color: 'green'
            });
        },
        ...config,
        mutationFn: activateUser
    });
}